import { StandardSvgProps } from 'src/components/svg/StandardSvgProps';
import { SDefaultSvg } from 'src/components/svg/SvgStyles';


export default function LoginSvg({ className }: StandardSvgProps) {
	return (
		<SDefaultSvg className={className} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20.402 20.402">
			<path d="M1760.2,931.4a10.2,10.2,0,1,1,10.2-10.2A10.2,10.2,0,0,1,1760.2,931.4Zm0-19.382a9.181,9.181,0,1,0,9.181,9.181A9.181,9.181,0,0,0,1760.2,912.02Zm5.189,6.865q1.194,2.948-1.244.958-2.372,2.074-1.275-.914-2.663-1.666.456-1.523.727-3.1,1.556-.027Q1767.993,917.127,1765.39,918.885Zm.008,3.591h1.051a6.377,6.377,0,0,1-12.5,0H1755a5.35,5.35,0,0,0,10.395,0Zm-8.079-3.591q1.193,2.948-1.245.958-2.372,2.074-1.275-.914-2.662-1.666.456-1.523.727-3.1,1.556-.027Q1759.925,917.127,1757.319,918.885Z" transform="translate(-1750 -911)" />
		</SDefaultSvg>
	);
}